<template>
  <div
  class="detail-summary"
  >
  <!-- <script type="application/javascript" defer src="../../api/scan.js"></script> -->
  <textarea style="margin: 5px 5px 0 5px" auto-focus="true" selectionDirection="backward"  id="consoleTextField" readonly="readonly" class="form-control" rows="5" v-model="barcode_scanned_readonly"></textarea>
  <div style="margin: 5px 5px 0 5px" class="input-group mb-3">
    <input type="tel" style="ime-mode:disabled" id="iTestInput" class="form-control" placeholder="Enter ticket number" v-model="barcode_scanned_input">
    <div class="input-group-append input-group-btn">
      <input type="button" class="btn btn-primary" id="bFireTestInput" @click="fireTestInput" value="手動輸入">
    </div>
  </div>    
  <!-- <div class="input_area">
    <div id="banner-message">
      <p>請先<strong style="color:red">點擊後</strong>，再掃描紙本票或手動輸入</p>
    <input type="text" id="input" v-model="inData" @change="passedData">
    </div>
  </div>  -->
  <!-- <pre>
    {{ this.parentVue.paper_merchant_id }}
  </pre> -->
  <b-alert 
    variant="success"
    :show="successMsg">
    已輸入{{ barcode_scanned_input }}成功！
  </b-alert>
  <b-alert 
    variant="danger"
    :show="alertMsg">
    輸入失敗！請輸入正確票號（2碼英文+8碼數字），或檢查是否切換成英打
  </b-alert> 
  <b-alert 
    variant="danger"
    :show="alertMsg1">
    重複輸入！
  </b-alert> 
  <span>
    累計張數 {{ totalCount }}
  </span>
  <span>
    累計總金額 {{ totalAmount }}
  </span>
  <!--每一筆itemDetails都要有_showDetails這個屬性(預設縮起值給false),toggtleDetails這個動作才有效果,才能展開/縮起該列詳細-->
  <b-table
      :items="createPFData1_child.itemDetails"
      :fields="summaryFields"
      :bordered="true"
  >
      <template v-slot:cell(actions)="row">
      <b-button @click="row.toggleDetails">{{row.item._showDetails?'隱藏明細':'展開明細'}}</b-button>
      </template>
      <template v-slot:row-details="row">
      <b-list-group>
          <b-list-group-item
          style="text-align:left"
          v-for="item in row.item.tickets" :key="item.ticket_no"
          >票號:{{item.ticket_no}}</b-list-group-item>
      </b-list-group>
      </template>
  </b-table>
  </div>
</template>
<script>
export default {
  /**
   * 輸入input -> click 或 enter -> 判斷符合僅英文、數字 -> 不合跳錯誤訊息/ input刪除 且 textarea也不會紀錄
   * 
   * 掃描（不需點擊input）即可自動帶入input、帶入textarea、input消失，若輸入中打或不合規範字，則跳錯誤訊息/ input刪除 textarea也不會紀錄
   * 
   * 進階 textarea 輸入到scroll可以自動顯示下行
   */
    props:{
      'parentVue':Object,
    },
    data(){
      return{
      ticket_item_ids:[],
      createPFData1_child:{
        'form_summary':"",
        'inside_ids':"",
        'invoice_date': "",
        'invoice_no': "",
        'itemDetails': [],
        'totalAmt':0,
        '_showDetails': false, 
      },
      successMsg: false,
      alertMsg:false,
      alertMsg1:false,
      barcode_scanned_readonly:'',
      barcode_scanned_input: '',
      loading: false,
      summaryFields:[
        {
          key:'ticket_name',
          label:'(以下是各課程小計)'
        },
        {
          key:'course_id',
          label:'簡稱'
        },
        {
          key:'cost_price',
          label:'單價'
        },
        {
          key:'count',
          label:'張數'
        },
        {
          key:'totalAmt',
          label:'小計(含稅)'
        },
        {
          key:'actions',
          label:'',
        },
      ],
        }
    },
    computed:{
      totalAmount: {
        get: function(){
          if(this.createPFData1_child.itemDetails.length == 0){
            return 0
          }
          else {
            // 回傳總金額 totalAmt
            let finalTotal = 0;
            for(let i = 0; i< this.createPFData1_child.itemDetails.length; i++){
              finalTotal += this.createPFData1_child.itemDetails[i].totalAmt;
            } 
            return finalTotal
          }
        },
        set: function(){

        }
      },
      totalCount: {
        get: function(){
          if(this.createPFData1_child.itemDetails.length == 0){
            return 0
          }
          else {
            // 回傳總金額 totalAmt
            let finalCount = 0;
            for(let i = 0; i< this.createPFData1_child.itemDetails.length; i++){
              finalCount += this.createPFData1_child.itemDetails[i].count;
            } 
            return finalCount
          }
        },
        set: function(){

        }
      },      
      // toSBC: function(){
      //   let str = document.getElementById('input');
      //   let result = '';
      //   if(str){

      //     let len = str.length;
      //     for(var i=0;i<len;i )
      //     {
      //         var cCode = str.charCodeAt(i);
      //         //全形與半形相差（除空格外）：65248（十進位制）
      //         cCode = (cCode>=0xFF01 && cCode<=0xFF5E)?(cCode-65248):cCode;
      //         //處理空格
      //         cCode = (cCode==0x03000)?0x0020:cCode;
      //         result = String.fromCharCode(cCode);
      //     }
      //   }
      //   return result;          
      // },
    },
    watch: {
    },
    created() {
      // Pass an options object with `eventBus: true` to receive an eventBus back
      // which emits `start` and `finish` events
      const eventBus = this.$barcodeScanner.init(this.onBarcodeScanned, { eventBus: true })
      if (eventBus) {
        // 掃描開始的瞬間
        eventBus.$on('start', () => { 
          this.loading = true;
          setTimeout(() => {
            document.getElementById('consoleTextField').scrollTo(0, 999999999);
          }, 100);
        })
        // 掃描結束的瞬間
        eventBus.$on('finish', () => {
            this.loading = false;
          // setTimeout(() => {
          //   this.barcode_scanned_input = '';
          // }, 900);
        })
      }
      this.$barcodeScanner.init(this.onBarcodeScanned)
    },
    destroyed () {
      // Remove listener when component is destroyed
      this.$barcodeScanner.destroy()
    },
    mounted(){  
    },  
    methods:{
      initDefault(){
        this.ticket_item_ids = [];
        this.alertMsg = false;
        this.alertMsg1 = false;
        this.successMsg = false;
        this.createPFData1_child = {
          'form_summary':"",
          'inside_ids':"",
          'invoice_date': "",
          'invoice_no': "",
          'itemDetails': [],
          'totalAmt':0,
          '_showDetails': false, 
        };
        this.barcode_scanned_readonly ='';
        this.barcode_scanned_input = '';
        this.loading = false;

      },
      onBarcodeScanned (barcode) {
        // 只能輸入英文數字
        let regex =  /^[a-zA-Z]{2}[0-9]{8}$/;
        if(!this.parentVue.paper_merchant_id){
          this.$bus.fnShowInfo("請先輸入供應商名稱")
          this.barcode_scanned_input = '';
          return
        }
        else if(!regex.test(barcode)){
          // console.log(barcode);
          this.alertMsg = true;
          setTimeout(() => {
            this.alertMsg = false;
          }, 1000);
          return
        }
        else {
          this.callapi_get_ticket(barcode);
        }
      },
      // Reset to the last barcode before hitting enter (whatever anything in the input box)
      resetBarcode () {
        let barcode = this.$barcodeScanner.getPreviousCode();
        // do something...
      },
      fireTestInput(){
        // 拿input值
        // 只能輸入英文數字
        let regex =  /^[a-zA-Z]{2}[0-9]{8}$/;
        if(!this.parentVue.paper_merchant_id){
          this.$bus.fnShowInfo("請先輸入供應商名稱")
          this.barcode_scanned_input = '';
          return
        }
        else if(!regex.test(this.barcode_scanned_input)){
          this.alertMsg = true;
          setTimeout(() => {
            this.alertMsg = false;
          }, 1000);
          return
        }
        else {
          this.callapi_get_ticket(this.barcode_scanned_input);
        }
      },
      callapi_get_ticket(ticket_number){
        // let ticket_no = ticket_number;
        let Param = {
          module:'admin_manage',
          method:'checkScannedPaperTicket',
          merchant_id: this.parentVue.paper_merchant_id,
          ticket_no: ticket_number,
          qrcode:'',
          credit_number:'',
        }
        let that = this
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // 重複輸入過的擋掉，BTW第一個不會檢查
          for(let i =0; i< that.createPFData1_child.itemDetails.length; i++){
            let double_input = that.createPFData1_child.itemDetails[i].tickets.some(function(item, index){
              return item.ticket_no == ticket_number
            })
            // console.log(double_input)
            if(double_input == true){
              that.alertMsg1 = true;
              setTimeout(() => {
                that.alertMsg1 = false;
              }, 1000);
              return
            }
          }
          ///////
          that.successMsg = true;
          setTimeout(() => {
            document.getElementById('consoleTextField').scrollTo(0, 999999999);
          }, 100);
          if(that.barcode_scanned_readonly == ''){
            that.barcode_scanned_readonly += 'Start Scan! \n'+ticket_number+data.data.ticket_project_name;
            that.barcode_scanned_input = '';
          }
          else{
            that.barcode_scanned_readonly += '\n'+ticket_number+data.data.ticket_project_name;
            that.barcode_scanned_input = '';
          }
          setTimeout(() => {
            that.successMsg = false;
          }, 800);
          // 組成一個新的ticketlist array 叫itemDetails，並賦予每個課程 _showDetails 屬性 default: false
          if(that.createPFData1_child.itemDetails.length == 0){
              // 新增一個課程列表
              let new_item = {
                'cost_price': data.data.cost_price,
                'count': 1,
                'course_id': "服務費",
                'product_id': data.data.product_id,
                'ticket_name': data.data.ticket_project_name,
                'tickets': [],
                'totalAmt': data.data.cost_price, // 只有一張票
                '_showDetails': false,
              }
              new_item.tickets.push(data.data);
              that.createPFData1_child.itemDetails.push(new_item);
              // console.log("新課程", that.createPFData1_child.itemDetails);            
          }
          else{
            let whichindex = null;
            let hasTheCourse = that.createPFData1_child.itemDetails.some(function(item, index){
              whichindex = index;
              return item.product_id == data.data.product_id
            })
            // console.log("hasCourse",hasTheCourse)
            if (hasTheCourse == true){
              that.createPFData1_child.itemDetails[whichindex].tickets.push(data.data);
              that.createPFData1_child.itemDetails[whichindex].count += 1;
              that.createPFData1_child.itemDetails[whichindex].totalAmt = (that.createPFData1_child.itemDetails[whichindex].count)*(that.createPFData1_child.itemDetails[whichindex].cost_price);
              // console.log("已有課程加一", that.createPFData1_child.itemDetails);          
            }
            else {
              // 新增一個課程列表
              let new_item = {
                'cost_price': data.data.cost_price,
                'count': 1,
                'course_id': "服務費",
                'product_id': data.data.product_id,
                'ticket_name': data.data.ticket_project_name,
                'tickets': [],
                'totalAmt': data.data.cost_price, // 只有一張票
                '_showDetails': false,
              }
              new_item.tickets.push(data.data);
              that.createPFData1_child.itemDetails.push(new_item);
              // console.log("新課程", that.createPFData1_child.itemDetails);              
            }
          }
          // 新組成 ticket_item_ids list 
          that.ticket_item_ids.push(data.data.ticket_item_id);
          that.createPFData1_child.inside_ids = that.ticket_item_ids.join(',');
          // 新組成 form_summary
          let mapform_summary = that.createPFData1_child.itemDetails.map(function(item, index){
            return `服務費_${item.count}_${item.cost_price}_${item.totalAmt}`
          })
          // console.log(mapform_summary)
          that.createPFData1_child.form_summary = mapform_summary.join(',');
          // console.log(that.createPFData1_child.form_summary);
        }, this)
    },
      },
    }
</script>
<style scoped>
.alertMsg {
  color: red;
}
.input_area {
  background: #ffffff;
  padding: 15px;
  font-family: Helvetica;
}
p {
  font-size: 18px;
}
#banner-message {
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  font-size: 20px;
  text-align: center;
  transition: all 0.2s;
  margin: 0 auto;
  width: 350px;
}
</style>